import { Account, AccountPostData, Profile } from '../MyLom/Account/EditAccount/Types';
import { ResetPasswordInterface } from '../ResetPassword/Types';

import { convertBirthDayToString } from './Util';

const shopUrl = window.__GGShopUrl || '';

export function updateAccount(
    account: Account,
    onSuccess: () => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    const body: AccountPostData = {
        ...account,
        birthDate: account.birthDate ? convertBirthDayToString(account.birthDate) : null,
    };

    fetch('/api/account/', {
        method: 'put',
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess();
            }
        })
        .catch((error) => {
            console.error('Server failure while updating account: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function updateProfiles(
    profiles: Profile[],
    onSuccess: () => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/account/profiles', {
        method: 'put',
        body: JSON.stringify({ profiles }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess();
            }
        })
        .catch((error) => {
            console.error('Server failure while updating profiles: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function logout(onSuccess: (json: any) => void, onError: (json: any) => void, onFailure?: (error: any) => void) {
    fetch(shopUrl + '/ggfrontendlogout', {
        method: 'get',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json);
            }
        })
        .catch((error) => {
            console.error('Server failure while trying to reach logout endpoint', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function resetPassword(
    payload: ResetPasswordInterface,
    onSuccess: () => void,
    onError: (errorMessages: string) => void,
    onFailure?: (error: any) => void,
) {
    fetch(shopUrl + '/ggfrontendforgotpassword', {
        method: 'post',
        credentials: 'include',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.success === true) {
                onSuccess();
            } else {
                onError(json.sErrorMessages);
            }
        })
        .catch((error) => {
            console.error('Server failure while trying to trigger "forgot password" action in Shopware API', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}
